'use client'

import React from 'react'
import { Icon } from '@/ui/atoms/Icon'

type TitleProps = {
  title: string
  isSignedIn?: boolean
  firstName?: string | null
}

export const DashboardTitle: React.FC<TitleProps> = ({ title, isSignedIn, firstName }) => {
  return (
    <div className="flex gap-2 items-center">
      <span className="text-headline-XL-semibold leading-[120%] text-text-inverted">
        <h1>
          {title}
          {isSignedIn && firstName && (
            <span className="inline-flex items-center gap-2 ml-2">
              {firstName}
              <span className={'ps-1'}>👋</span>
            </span>
          )}
        </h1>
      </span>
    </div>
  )
}
